import { ChangeDetectorRef, Component, HostListener, ViewEncapsulation } from "@angular/core";
import moment from "moment";
import dayJs from "dayjs";
import { firstValueFrom } from "rxjs";
import { AttendanceService } from "./attendance-report.service";
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import * as string from "../stringFiles/attendanceReport.json";


declare var $: any;
declare var customToastr: any;
@Component({
    selector: "app-attendance-report",
    providers: [AttendanceService],
    templateUrl: "./attendance-report.component.html",
    styleUrls: [
        "./attendance-report.component.css",
        "./../../assets/css/theme-default/materialadmin.css",
        "./../../assets/css/theme-default/font-awesome.min.css",
        "./../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css",
        "./../../assets/css/theme-default/material-design-iconic-font.min.css",
        "./../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css",
        "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css",
        "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css",
        "./../../_crop/css/style.css",
        "./../../_crop/css/style-example.css",
    ],
    encapsulation: ViewEncapsulation.None,
})
export class AttendanceReportComponent {
    private langChangeSubscription: any;
    isFilterExpanded: boolean = false;
    isOpenStudentSelection: boolean = false;
    isOptionOpened: boolean = false;
    optionHeaderIndex: string = "";
    allStudentSelected: boolean = false;
    selectedWing: any = null;
    selectedSection: any = null;
    selectedClass: any = null;
    wingListData: any = [];
    classStandardData: any = [];
    classSectionData: any = [];
    genderData: any = [];
    selectedGender: any = null;
    studentList: any = [];
    selectedStudentListLength: any = "";
    selectedStartDate: string = "";
    selectedEndDate: string = "";
    todayDate: string = dayJs(new Date()).format("YYYY-MM-DD");
    academicStartDate: string = "";
    resultLength: string = "0";
    studentStatData: any = [];
    attendanceClassData: any = [];
    startingPageNumber: any = 1;
    pageNumbers: any = [];
    maxPageNumber: any = "";
    pageLimit: any = "";
    tableHeaderData: any = [];
    tableBodyData: any = [];
    pageLimitForClassWiseDate: any = "10";
    resultAvailable: any = "";
    appliedWing: any = "All";
    appliedClass: any = "All";
    appliedSection: any = "All";
    appliedDate: any = "Today";
    appliedGender: any = "All";
    appliedStudent: any = "";
    string: any;
    loadingStatData: boolean = true;
    loadingClassTileData: boolean = true;
    loadingClassTableData: boolean = false;
    loadingWingData: boolean = true;
    loadingClassData: boolean = false;
    loadingSectionData: boolean = false;
    enableReset: boolean = false;
    enableBackButton: boolean = false;
    isExportingReport = false;
    loadingStudentDropdownData: boolean = false;
    completeStudentList = [];
    isFocused: boolean = false;
    filterWingId: any='All';
    filterClassId:any='All';
    filterSectionId:any='All';
    filterStartDate:any=this.todayDate;
    filterEndDate:any=this.todayDate;
    filterGender:any='All';
    filterSelectedStudent:any='All';
    isSelectedStudentCountDisplay = true;

    appliedSelectedStartDate : any = null;
    appliedSelectedEndDate : any = null;
    appliedWingId : any = "All";
    appliedClassId : any = "All";
    appliedStandardId : any = "All";
    appliedGenderId : any = "All";
    selectedStudent : any = "All";

    constructor(
        private attendanceService: AttendanceService,
        private translate: TranslateService
    ) {
        this.tileDataOrTableData();
        this.getGenderListData();
        this.getClassAttendanceStats();
        this.getClassData();
        this.todayDate = dayJs(new Date()).format("YYYY-MM-DD");
        this.academicStartDate = localStorage.getItem("academicStartDate");
        this.string = string;
    }

    ngOnInit(): void {
        this.setTranslatedDefaults();
        this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.setTranslatedDefaults(); 
        });
    }

    setTranslatedDefaults(): void {
        this.translate.get([
            'all',
            'today'
        ]).subscribe(translations => {
            this.appliedWing = translations['all'];
            this.appliedClass = translations['all'];
            this.appliedSection = translations['all'];
            this.appliedDate = translations['today'];
            this.appliedGender = translations['all'];
            this.selectedStudent = translations['all'];

            this.filterWingId = translations['all'];
            this.filterClassId = translations['all'];
            this.filterSectionId = translations['all'];
            this.filterGender = translations['all'];
            this.filterSelectedStudent = translations['all'];

            this.appliedWingId = translations['all'];
            this.appliedClassId = translations['all'];
            this.appliedStandardId = translations['all'];
            this.appliedGenderId = translations['all'];
        });
        
    }

    ngOnDestroy(): void {
        if (this.langChangeSubscription) {
            this.langChangeSubscription.unsubscribe();
        }
    }
    // init script for toast messages
    initScript() {
        $(".after").empty();
        $("#device-breakpoints").remove();
        $(".after").append(
            "<script>function customToastr(message,type){toastr.options.hideDuration = 0;toastr.clear();" +
            "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;" +
            "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
            "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
            "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';" +
            "toastr[type](message, '');return 0;} </" +
            "script>"
        );
    }

    // function for expand all filters
    expandAllFilterItems() {
        this.isFilterExpanded = !this.isFilterExpanded;
    }

    // function for calendar's configuration
    selected: { startDate: moment.Moment; endDate: moment.Moment };
    locale = {
        format: "DD MMM,YY", // Date format
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        customRangeLabel: "Custom Range",
    };
    ranges = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
        ],
    };
    rangeClicked(range): void {
        this.selectedStartDate = range.dates[0]
            ? dayJs(range.dates[0]).format("YYYY-MM-DD")
            : dayJs(new Date()).format("YYYY-MM-DD");
    }

    datesUpdated(range): void {
        this.selectedStartDate = range.startDate
            ? dayJs(range.startDate).format("YYYY-MM-DD")
            : dayJs(new Date()).format("YYYY-MM-DD");
        this.selectedEndDate = range.endDate
            ? dayJs(range.endDate).format("YYYY-MM-DD")
            : dayJs(new Date()).format("YYYY-MM-DD");
    }

    // function to focus on search input box
    onFocusSearchInput() {
        this.isFocused = true;
        this.isOpenStudentSelection = true;
        this.studentList = [...this.completeStudentList];
    }

    // function to blur on search input box
    onBlurSearchInput() {
        this.isFocused = false;
    }

    // function trigger on user inputs in the search box
    onSearchChange(val) {
        this.isOpenStudentSelection = true;
        const value = val.toLowerCase();
        if (value) {
            this.studentList = this.completeStudentList.filter(user =>
                user.studentName.toLowerCase().includes(value)
            );
        }
    }

    // function for close student selection option
    closeStudentSelection() {
        this.isOpenStudentSelection = false;
    }

    // function for close student dropdown from table header
    openTableHeadersOption(index) {
        if (index === this.optionHeaderIndex) {
            this.optionHeaderIndex = "";
        } else {
            this.optionHeaderIndex = index;
        }
    }

    // function for close table header option
    closeCollapseOptionTable() {
        this.optionHeaderIndex = "";
    }

    // api for get class data in filter section
    async getClassData() {
        try {
            this.classStandardData = [];
            this.selectedClass = null;
            this.selectedSection = null;
            this.classSectionData = [];
            this.allStudentSelected = false;
            this.studentList = [];
            this.completeStudentList = [];
            this.loadingWingData = true;
            const response: any = await firstValueFrom(
                this.attendanceService.getClassListData()
            );
            if (response.status && response.body) {
                this.wingListData = response.body.classCategoryListDetailsForAttendance
                    ? response.body.classCategoryListDetailsForAttendance
                    : [];
            } else {
                this.wingListData = [];
            }
            this.loadingWingData = false;
        } catch (error) {
            this.loadingWingData = false;
            this.wingListData = [];
            if (error.message.message) {
                customToastr(error.message.message, 'error');
            } else {
                const translations = await firstValueFrom(this.translate.get(['defaultErrorMessage' ]));
                customToastr(translations['defaultErrorMessage'], 'error');
            }
        }
    }

    // api for get class category data
    async getClassCategoryData(selectedWing) {
        try {
            this.loadingClassData = true;
            this.classStandardData = [];
            this.selectedClass = null;
            this.selectedSection = null;
            this.classSectionData = [];
            this.studentList = [];
            this.completeStudentList = [];
            const wingId = selectedWing.categoryId;
            const response: any = await firstValueFrom(
                this.attendanceService.getClassStandardList(wingId)
            );
            if (response.status && response.body) {
                this.classStandardData = response.body
                    .classCategoryListDataForAttendance
                    ? response.body.classCategoryListDataForAttendance
                    : [];
            } else {
                this.classStandardData = [];
            }
            this.loadingClassData = false;
        } catch (error) {
            this.loadingClassData = false;
            this.classStandardData = [];
            if (error.message.message) {
                customToastr(error.message.message, 'error');
            } else {
                const translations = await firstValueFrom(this.translate.get(['defaultErrorMessage' ]));
                customToastr(translations['defaultErrorMessage'], 'error');
            }
        }
    }

    // api for get class section data
    async getClassSectionData(selectedClass) {
        try {
            this.selectedSection = null;
            this.classSectionData = [];
            this.studentList = [];
            this.completeStudentList = [];
            this.allStudentSelected = false;
            this.selectedStudentListLength = '';
            this.loadingSectionData = true;
            const wingId = this.selectedWing.categoryId;
            const classId = selectedClass.classStandardId;
            const response: any = await firstValueFrom(
                this.attendanceService.getClassSectionData(wingId, classId)
            );
            if (response.status && response.body) {
                this.classSectionData = response.body.classSectionListDataForAttendance
                    ? response.body.classSectionListDataForAttendance
                    : [];
            } else {
                this.classSectionData = [];
            }
            this.loadingSectionData = false;
        } catch (error) {
            this.loadingSectionData = false;
            this.classSectionData = [];
            if (error.message.message) {
                customToastr(error.message.message, 'error');
            } else {
                const translations = await firstValueFrom(this.translate.get(['defaultErrorMessage', 'errorCode']));
                customToastr(translations['defaultErrorMessage'], 'error');
            }
        }
    }

    // api for get gender list data
    async getGenderListData() {
        try {
            const response: any = await firstValueFrom(
                this.attendanceService.getGenderList()
            );
            if (response.status && response.body) {
                this.genderData = response.body.studentGenderListDetails
                    ? response.body.studentGenderListDetails
                    : [];
            } else {
                this.genderData = [];
            }
        } catch (error) {
            this.genderData = [];
            if (error.message.message) {
                customToastr(error.message.message, 'error');
            } else {
                const translations = await firstValueFrom(this.translate.get(['defaultErrorMessage', 'errorCode']));
                customToastr(translations['defaultErrorMessage'], 'error');
            }
        }
    }

    // get student list data in filter section
    async getStudentData(sectionId) {
        try {
            this.studentList = [];
            this.completeStudentList = [];
            this.allStudentSelected = false;
            this.selectedStudentListLength = '';
            this.loadingStudentDropdownData = true;
            const wingId = this.selectedWing.categoryId;
            const classCategoryId = this.selectedClass.classStandardId;
            const section = sectionId.classId;
            const gender = this.selectedGender?.studentGender
                ? this.selectedGender.studentGender
                : "All";
            const response: any = await firstValueFrom(
                this.attendanceService.getStudentListData(
                    wingId,
                    classCategoryId,
                    section,
                    gender
                )
            );
            if (response.status && response.body) {
                this.completeStudentList = response.body.studentListForAttendance
                    ? response.body.studentListForAttendance
                    : [];
            }
            this.loadingStudentDropdownData = false;
            this.studentList = [...this.completeStudentList];
        } 
        catch (error) {
            this.studentList = [];
            this.loadingStudentDropdownData = false;
            this.completeStudentList = [];
            this.allStudentSelected = false;
            this.selectedStudentListLength = '';
            if (error.message.message) {
                customToastr(error.message.message, 'error');
            } else {
                const translations = await firstValueFrom(this.translate.get(['defaultErrorMessage', 'errorCode']));
                customToastr(translations['defaultErrorMessage'], 'error');
            }
        }
    }

    // function for apply "All" filter in filter
    applyAllWing() {
        this.classStandardData = [];
        this.selectedClass = null;
        this.selectedSection = null;
        this.classSectionData = [];
        this.studentList = [];
        this.completeStudentList = [];
        this.allStudentSelected = false;
        this.selectedStudentListLength = '';
    }
    // Click outside close the dropdown list
    @HostListener('document:click', ['$event'])
        onDocumentClick(event: Event) {
            this.isOpenStudentSelection = false;
        }
    
    // function for apply "All" class  in filter
    applyAllClass() {
        this.selectedSection = null;
        this.classSectionData = [];
        this.studentList = [];
        this.completeStudentList = [];
        this.allStudentSelected = false;
        this.selectedStudentListLength = '';
    }

    // function for apply "All" section  in filter
    applyAllSection() {
        this.allStudentSelected = false;
        this.selectedStudentListLength = "";
        this.studentList = [];
        this.completeStudentList = [];
    }

    // function for select student in filter option
    markStudent(data, event: Event) {
        const findData = this.studentList[data];
        findData.isChecked = !findData.isChecked;
        this.updateSelectedStudentCount();
        this.checkAllMarked();
    }

    // function for check all student in filter option
    checkAllMarked() {
        this.allStudentSelected = this.completeStudentList.every(
            (student) => student.isChecked
        );
    }

    // function for select all student in filter option  
    markAllStudent(value) {
        const isChecked = value.checked;
        this.completeStudentList.forEach((student) => {
            student.isChecked = isChecked;
        });

        this.studentList.forEach((student) => {
            student.isChecked = isChecked;
        });

        this.updateSelectedStudentCount();
        this.allStudentSelected = isChecked;
    }

    // function to update the student count
    updateSelectedStudentCount() {
        this.selectedStudentListLength = this.completeStudentList.filter(
            (student) => student.isChecked
        ).length;
    }

    // function for fetch student list in filter
    callClassStudentListData() {
        if (this.selectedSection != null) {
            this.studentList = [];
            this.selectedStudentListLength = '';
            this.completeStudentList = [];
            this.allStudentSelected = false;
            this.getStudentData(this.selectedSection);
        }
    }

    // function for apply all gender
    applyAllGender() {
        this.callClassStudentListData();
    }

   // function for generate student string through array
   getStudentListForAttendance() {
    const data = this.completeStudentList.filter(
        (student) => student.isChecked === true
    );
  
    
    if (data.length === this.completeStudentList.length) return "All";
    if (data.length > 0) {
        const studentIdString = data
            .map((student) => student.studentId)
            .join(",");
        return studentIdString;
    } else {
        return "All";
    }
    }

    //  function for get stats for student attendance
    async getClassAttendanceStats() {
        try {
            this.loadingStatData = true;
            const payload = {
                classCategoryId: this.appliedWingId,
                classStandardId: this.appliedStandardId ,
                classId: this.appliedClassId,
                gender: this.appliedGender,
                startDate: this.appliedSelectedStartDate ==null ? this.todayDate : this.appliedSelectedStartDate,
                endDate: this.appliedSelectedEndDate ==null ? this.todayDate : this.appliedSelectedEndDate,
                studentList: this.getStudentListForAttendance(),
            };
            const response: any = await firstValueFrom(
                this.attendanceService.getStatData(payload)
            );
            if (response.status && response.body) {
                this.studentStatData = response.body.attendanceCount
                    ? response.body.attendanceCount
                    : [];
                this.resultAvailable = response.body.resultAvailable
                    ? response.body.resultAvailable
                    : "0";
            }
            this.loadingStatData = false;
        } catch (error) {
            this.loadingStatData = false;
            if (error.message.message) {
                customToastr(error.message.message, 'error');
            } else {
                const translations = await firstValueFrom(this.translate.get(['defaultErrorMessage', 'errorCode']));
                customToastr(translations['defaultErrorMessage'], 'error');
            }
        }
    }

    // function for apply filter
    async applyFilter() {
        


        this.appliedWingId = (this.selectedWing !== null && this.selectedWing !== undefined)
    ? this.selectedWing.categoryId
    : "All";

this.appliedStandardId = (this.selectedClass !== null && this.selectedClass !== undefined)
    ? this.selectedClass.classStandardId
    : "All";

this.appliedClassId = (this.selectedSection !== null && this.selectedSection !== undefined)
    ? this.selectedSection.classId
    : "All";


        this.appliedSelectedStartDate = this.selectedStartDate ? dayJs(this.selectedStartDate).format('YYYY-MM-DD') : this.todayDate;
        this.appliedSelectedEndDate =this.selectedEndDate ? dayJs(this.selectedEndDate).format('YYYY-MM-DD') : this.todayDate;
        this.appliedGenderId =  this.selectedGender ? this.selectedGender.studentGender  : "All";
        this.selectedStudent = this.getStudentListForAttendance();

        this.appliedWing = this.selectedWing
            ? this.selectedWing.categoryName
            : "All";
        this.appliedClass = this.selectedClass
            ? this.selectedClass.classStandardName
            : "All";
        this.appliedSection = this.selectedSection
            ? this.selectedSection.classDivision
            : "All";
        this.appliedDate =
            this.todayDate === this.selectedStartDate &&
                this.todayDate === this.selectedEndDate
                ? "Today"
                : this.selectedStartDate === this.selectedEndDate
                    ? dayJs(this.selectedStartDate).format("DD MMM YYYY")
                    : dayJs(this.selectedStartDate).format("DD MMM YYYY") +
                    " to " +
                    dayJs(this.selectedEndDate).format("DD MMM YYYY");
        this.appliedGender = this.selectedGender
            ? this.selectedGender.studentGender
            : "All";
        this.appliedStudent =
            this.selectedStudentListLength > 0 ? this.selectedStudentListLength : "";
        this.startingPageNumber = 1;
        this.getClassAttendanceStats();
        this.tileDataOrTableData();
        this.enableReset = true;
        this.filterWingId=this.selectedWing
        ? this.selectedWing.categoryId
        : "All";
        this.filterClassId= this.selectedClass
        ? this.selectedClass.classStandardId
        : "All";
        this.filterSectionId=
        this.selectedSection
            ? this.selectedSection.classId
            : "All";
        this.filterStartDate=this.selectedStartDate;
        this.filterEndDate=this.selectedEndDate;
        this.filterGender= this.selectedGender
        ? this.selectedGender.studentGender
        : "All";
        this.filterSelectedStudent = this.getStudentListForAttendance(); 
        if (this.selectedStudentListLength === this.completeStudentList.length){
            this.isSelectedStudentCountDisplay = false;
        }
        else{
            this.isSelectedStudentCountDisplay = true;
        }
    }

    // function for get class tile data
    async getAllClassData(pageNumber) {
        try {
            this.loadingClassTileData = true;
            const payload = {
                classCategoryId: this.appliedWingId,
                classStandardId: this.appliedStandardId,
                gender: this.appliedGenderId,
                startDate: this.appliedSelectedStartDate==null ? this.todayDate :  this.appliedSelectedStartDate,
                endDate: this.appliedSelectedEndDate ===null ? this.todayDate :  this.appliedSelectedEndDate ,
                limit: 12,
                pageNumber: pageNumber,
            };
            const response: any = await firstValueFrom(
                this.attendanceService.getAllClassData(payload)
            );
            if (response.status && response.body) {
                this.attendanceClassData = response.body.reportClassData
                    ? response.body.reportClassData
                    : [];
                this.generatePageNumber(response.body.maxPageNumber);
            }
            this.loadingClassTileData = false;
        } catch (error) {
            this.loadingClassTileData = false;
            if (error.message.message) {
                customToastr(error.message.message, 'error');
            } else {
                const translations = await firstValueFrom(this.translate.get(['defaultErrorMessage', 'errorCode']));
                customToastr(translations['defaultErrorMessage'], 'error');
            }
        }
    }

    // function for generate page number
    generatePageNumber(maxPage) {
        this.maxPageNumber = maxPage;
        let displayedPages = [];
        let currentPage = this.startingPageNumber;

        if (maxPage < 4) {
            displayedPages = Array.from({ length: maxPage }, (_, i) => i + 1);
        } else {
            if (currentPage === 1) {
                displayedPages.push(
                    ...Array.from({ length: Math.min(5, maxPage) }, (_, i) => i + 1)
                );
            } else if (currentPage === maxPage) {
                displayedPages.push(
                    ...Array.from(
                        { length: Math.min(5, maxPage) },
                        (_, i) => maxPage - 4 + i
                    )
                );
            } else if (currentPage >= 4 && currentPage <= maxPage - 3) {
                displayedPages.push(
                    ...Array.from({ length: 5 }, (_, i) => currentPage - 2 + i)
                );
            } else if (currentPage < 4) {
                displayedPages.push(
                    ...Array.from({ length: Math.min(5, maxPage) }, (_, i) => i + 1)
                );
            } else if (currentPage > maxPage - 4) {
                displayedPages.push(
                    ...Array.from(
                        { length: Math.min(5, maxPage) },
                        (_, i) => maxPage - 4 + i
                    )
                );
            }

            displayedPages = displayedPages
                .filter((page) => page > 0 && page <= maxPage)
                .sort((a, b) => a - b);

            if (!displayedPages.includes(maxPage)) {
                displayedPages.push("...");
                displayedPages.push(maxPage);
            }
        }

        this.pageNumbers = displayedPages;
    }

    // function for jump page number on click of page number
    switchPageNumber(pageNumber) {
        this.startingPageNumber = pageNumber;
        this.tileDataOrTableData();
    }

    // function for page switch
    changePageLimitData(pageNumber) {
        this.startingPageNumber = pageNumber;
        this.pageLimit = pageNumber;
        this.tileDataOrTableData();
    }

    // function for get specific class wise data
    async getClassWiseData(limit) {
        try {
            this.loadingClassTableData = true;
            const payload = {
                classCategoryId: this.appliedWingId,
                classStandardId: this.appliedStandardId,
                classId: this.appliedClassId,
                gender: this.appliedGenderId,
                startDate: this.appliedSelectedStartDate ==null ? this.todayDate : this.appliedSelectedStartDate,
                endDate: this.appliedSelectedEndDate ==null ? this.todayDate : this.appliedSelectedEndDate,
                pageNumber: this.startingPageNumber,
                studentList: this.selectedStudent,
                pageLimit: limit,
            };

            const response: any = await firstValueFrom(
                this.attendanceService.getStudentDataClassWise(payload)
            );
            if (response.status && response.body) {
                if (this.tableHeaderData.length === 0) {
                    this.tableHeaderData = response.body.reportColumnList
                        ? response.body.reportColumnList
                        : [];
                }
                this.generatePageNumber(response.body.maxPageNumber);
                this.tableBodyData = response.body.reportStudentData
                    ? response.body.reportStudentData
                    : [];
                this.loadingClassTableData = false;
            }
        } catch (error) {
            this.loadingClassTableData = false;
            if (error.message.message) {
                customToastr(error.message.message, 'error');
            } else {
                const translations = await firstValueFrom(this.translate.get(['defaultErrorMessage', 'errorCode']));
                customToastr(translations['defaultErrorMessage'], 'error');
            }
        }
    }

    // function for decide which data need to be visible
    tileDataOrTableData() {

        if (this.appliedClassId =="All") {
            this.getAllClassData(this.startingPageNumber);
            this.tableHeaderData = [];
            this.tableBodyData = [];
        } else {
            this.attendanceClassData = [];
            this.getClassWiseData(this.pageLimitForClassWiseDate);
        }
    }

    // function for update table header
    async updateTableColumn(currentSlug, newSlug) {
        const currentSlugDataIndex = this.tableHeaderData.findIndex((item) => {
            const data = item as any;
            return data.slug === currentSlug;
        });
        const newSlugDataIndex = this.tableHeaderData.findIndex((item) => {
            const data = item as any;
            return data.slug === newSlug;
        });
        if (currentSlugDataIndex !== -1 && newSlugDataIndex !== -1) {
            const slugCurrentData = this.tableHeaderData[currentSlugDataIndex];
            const slugNewData = this.tableHeaderData[newSlugDataIndex];
            const currentInfo = slugCurrentData as any;
            const newInfo = slugNewData as any;
            currentInfo.isDefault = 0;
            newInfo.isDefault = 1;
            if (this.tableHeaderData.length > 0) {
                this.tableHeaderData[currentSlugDataIndex] = newInfo;
                this.tableHeaderData[newSlugDataIndex] = currentInfo;
            }
        }
    }

    // function for change page limit for class table data
    changePageLimit(limit) {
        this.startingPageNumber = 1;
        this.pageLimitForClassWiseDate = limit;
        this.getClassWiseData(limit);
    }

    // function for reset filter
    resetAllFilter() {
        this.filterWingId='All';
        this.filterClassId='All';
        this.filterSectionId='All';
        this.filterStartDate= this.todayDate;
        this.filterEndDate= this.todayDate;
        this.filterGender= 'All';
        this.filterSelectedStudent='All';
        this.selectedClass = null;
        this.selectedWing = null;
        this.selectedSection = null;
        this.selectedGender = null;
        this.classSectionData = [];
        this.classStandardData = [];
        this.studentList = [];
        this.completeStudentList = [];
        this.selectedStudentListLength = "";
        this.selectedStartDate = this.todayDate;
        this.selectedEndDate = this.todayDate;
        this.allStudentSelected = false;
        this.applyFilter();
        this.enableReset = false;
        this.enableBackButton = false;
    }

    // function for open class info using selected tile
    fetchSelectedClassData(data) {
        this.selectedClassFilter(data);
    }

    // function for apply filter according to class selection from tile
    selectedClassFilter(data) {
        this.selectedWing = null;
        this.selectedClass = null;
        this.selectedSection = null;
        this.selectedWing = {
            categoryId: data.categoryId,
            categoryName: data.categoryName,
        };
        this.selectedSection = {
            classId: data.classId,
            classDivision: data.classDivision,
        };
        this.selectedClass = {
            classStandardId: data.classStandardId,
            classStandardName: data.classStandard,
        };
        this.appliedWingId =  data.categoryId;
        this.appliedClassId =  data.classId,
        this.appliedStandardId =  data.classStandardId, 
        this.startingPageNumber = 1;
        this.enableBackButton = true;
        this.getStudentData(this.selectedSection);
        this.getClassAttendanceStats();
        this.tileDataOrTableData();
        this.appliedWing = this.selectedWing
            ? this.selectedWing.categoryName
            : "All";
        this.appliedClass = this.selectedClass
            ? this.selectedClass.classStandardName
            : "All";
        this.appliedSection = this.selectedSection
            ? this.selectedSection.classDivision
            : "All";
        this.filterWingId=this.selectedWing
            ? this.selectedWing.categoryId
            : "All";
        this.filterClassId= this.selectedClass
            ? this.selectedClass.classStandardId
            : "All";
        this.filterSectionId=
            this.selectedSection
                ? this.selectedSection.classId
                : "All";
        this.filterStartDate=this.selectedStartDate;
        this.filterEndDate=this.selectedEndDate;
        this.filterGender= this.selectedGender
            ? this.selectedGender.studentGender
            : "All";
            this.filterSelectedStudent = this.getStudentListForAttendance(); 
    }

    // function for export attendance report and download it directly
    async exportReport() {
        try {
            this.isExportingReport = true;
            const schoolData = localStorage.getItem('schoolAllInfo');
            const schoolDataParsed = JSON.parse(schoolData);
            const tableColumnArray = [];
            for (let j = 0; j < this.tableHeaderData.length; j++) {
                const tableData: any = this.tableHeaderData[j];
                if (tableData.isDefault == 1) {
                    tableColumnArray.push(tableData.pkReportColumnMapDetailId);
                }
            }

            const body = {
                lang: 'en',
                academicId: schoolDataParsed.currentAcademicId,
                exportType: this.string.reportFormat,
                selectedColumns: tableColumnArray.length == 0 ? "" : tableColumnArray,
                classCategoryId: this.filterWingId,
                classStandardId: this.filterClassId,
                classId: this.filterSectionId,
                gender: this.filterGender,
                startDate: this.filterStartDate,
                endDate: this.filterEndDate,
                studentIdList: this.filterSelectedStudent
            };
            const response: any = await firstValueFrom(
                this.attendanceService.exportReportData(body)
            );
            if (response instanceof Blob) {
                const blob = response;
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `AttendanceReport_${this.filterStartDate}_${this.filterEndDate}.xlsx`;
                a.click();
                window.URL.revokeObjectURL(url);
            }
            const successMsg = await firstValueFrom(this.translate.get('reportExportedSuccessfully'));
            customToastr(successMsg, 'success');
        }
        catch (error) {
            const translations = await firstValueFrom(this.translate.get(['errorExport']));
            customToastr(
                error.error && error.error.message
                    ? error.error.message
                    : translations['errorExport'],
                'error'
            );
        }
        finally {
            this.isExportingReport = false;
        }
    }
}